import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITravelActivityInitialState } from "./travelActivityModel";
import {
  getAllTravelActivity,
  getAllActiveTravelActivity,
  getTravelActivityByID,
  activeInactiveTravelActivity
} from "./services/travelActivity.services";

const initialState: ITravelActivityInitialState = {
  TravelActivityList: [],
  TravelActivityDetails: null,
  TravelActivityID: null,
  loading: false,
  error: null,
};

const travelActivitySlice = createSlice({
  name: "travelActivity",
  initialState,
  reducers: {
    setTravelActivityID: (state, action: PayloadAction<number | null>) => {
      state.TravelActivityID = action.payload;
    },
    clearTravelActivityID: (state) => {
      state.TravelActivityID = null;
    },
    clearTravelActivityDetails: (state) => {
      state.TravelActivityDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getAllTravelActivity
      .addCase(getAllTravelActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTravelActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.TravelActivityList = action.payload;
      })
      .addCase(getAllTravelActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch travel activities";
      })

      // getAllActiveTravelActivity
      .addCase(getAllActiveTravelActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllActiveTravelActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.TravelActivityList = action.payload;
      })
      .addCase(getAllActiveTravelActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch active travel activities";
      })

      // activeInactiveTravelActivity
      .addCase(activeInactiveTravelActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(activeInactiveTravelActivity.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(activeInactiveTravelActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      })

      // getTravelActivityByID
      .addCase(getTravelActivityByID.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTravelActivityByID.fulfilled, (state, action) => {
        state.loading = false;
        state.TravelActivityDetails = action.payload;
      })
      .addCase(getTravelActivityByID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch travel activity details";
      });
  },
});

export const {
  setTravelActivityID,
  clearTravelActivityID,
  clearTravelActivityDetails
} = travelActivitySlice.actions;

export default travelActivitySlice.reducer;
